import { render, staticRenderFns } from "./TagLink.vue?vue&type=template&id=60484a0f&"
import script from "./TagLink.vue?vue&type=script&lang=js&"
export * from "./TagLink.vue?vue&type=script&lang=js&"
import style0 from "./TagLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports